export const ShortcutActionName = {
    UNDO: 'undo',
    REDO: 'redo',
    FORWARD: 'forward',
    BACKWARD: 'backward',
    FRONT: 'front',
    BACK: 'back',
    // CHANGETEXTINCLINE: 'changeTextIncline',
    CUT: 'cut',
    COPY: 'copy',
    PASTE: 'paste',
    CTRL: 'ctrl',
    DELETE: 'delete',
    SELECTALL: 'selectAll',
    PLAY: 'play',
    UP: 'up',
    DOWN: 'down',
    LEFT: 'left',
    RIGHT: 'right',
    PAGEUP: 'pageup',
    PAGEDOWN: 'pagedown',
    HOME: 'home',
    END: 'end',
    ESC: 'esc',
    NEWSLIDE_ENTER: 'newSlideEnter',
    NEWSLIDE_M: 'newSlideM',
    ITALIC: 'italic',
    BOLD: 'bold',
    DELETE_LINE: 'delete-line',
    UNDERLINE: 'underline',
    MOUSEWHEEL: 'mousewheel',
    TABACTION: 'tabAction',
    BLOCKCTRL_S: 'blockCtrlS',
    ADD_GROUP: 'addGroup',
    REMOVE_GROUP: 'removeGroup',
    SEARCH: 'search',
    REPLACE: 'replace',
    ACCESSIBILITY: 'accessibility',
    SHORTCUTPANEL: 'shortcutPanel',
    LINK: 'link',
    HIDE_SHOW_TOP_BAR: 'hideShowTopBar',
    DISPLAY_GUIDES: 'displayGuides',
    DISPLAY_GRID_LINE: 'displayGridLine',
    PRINT: 'print',
    INSERT_COMMENT: 'insertComment',
} as const;
